export default "__VITE_ASSET__sfxpWaDX__"